import api from "@/api";

export default {
    namespaced: true,
    state: () => ({
        favorites: [],
        loading: false
    }),
    getters: {
        allFavorites: (state) => state.favorites,
        isFavorite: (state) => (itemId, itemType) => {
            return state.favorites.some(f => f.item_id === itemId && f.item_type === itemType);
        }
    },
    mutations: {
        SET_FAVORITES(state, favorites) {
            state.favorites = favorites;
        },
        ADD_FAVORITE(state, favorite) {
            state.favorites.unshift(favorite);
        },
        REMOVE_FAVORITE(state, { itemId, itemType }) {
            state.favorites = state.favorites.filter(f => !(f.item_id === itemId && f.item_type === itemType));
        },
        SET_LOADING(state, status) {
            state.loading = status;
        }
    },
    actions: {
        async fetchFavorites({ commit }) {
            commit("SET_LOADING", true);
            try {
                const res = await api.get("/user/favorites");
                commit("SET_FAVORITES", res.data);
            } catch (error) {
                console.error("Fetch Favorites Error:", error);
            } finally {
                commit("SET_LOADING", false);
            }
        },
        async toggleFavorite({ commit, getters }, { itemId, itemType }) {
            try {
                const res = await api.post("/user/favorites/toggle", { itemId, itemType });
                if (res.data.status === 'added') {
                    // We might need to fetch the full object if we want it to show up immediately in the list
                    // For now, just re-fetch everything to be safe and consistent
                    const allFavs = await api.get("/user/favorites");
                    commit("SET_FAVORITES", allFavs.data);
                } else {
                    commit("REMOVE_FAVORITE", { itemId, itemType });
                }
                return res.data;
            } catch (error) {
                console.error("Toggle Favorite Error:", error);
                throw error;
            }
        }
    }
};
